/* eslint-disable no-cond-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */

// import _ from 'lodash';
import _ from 'lodash';
import { ModelRuleData, ModelRuleDependenciesData, ModelRuleGroupData } from './modelRuleData';
import { SLTXFormatRootFile } from '../../fileFormats/sltx/sltx';
import { TreeOptionSelections } from '../data/optionsSelection';
import { ModelTreeNode, ParsedTreeNodeType } from '../data/modelOptionsTree';
import { ConditionEvaluator } from './rulesConditionEvaluator';

type RuleParts = {
  actions: string[],
  actionLevel: number,
  conditions: string[],
  conditionLevel: number
};

type RuleValueFilter = {
  includeAll: boolean, // false = whitelist, true = all values except values[]
  values: string[]
};

type ParsedRuleValuePredicate = {
  predicate: string,
  negativePredicate: boolean,
  plusValues: string[],
  minusValues: string[]
};

type ConditionParseResult = {
  condition: string;
  consequence1: string;
  consequence2: string;
};

export class RulesEvaluationDependencies {

  public static evaluateRule(
    dependenciesRule : ModelRuleData,
    optionsSelectionState : TreeOptionSelections,
    modelTree : ModelTreeNode,
    sltxFile : SLTXFormatRootFile,
  ) : ModelTreeNode {

    if (dependenciesRule === undefined || dependenciesRule.ruleDataDependencies === undefined) {
      return modelTree;
    }

    const { conditions, actions } = dependenciesRule.ruleDataDependencies;

    let predicates : RuleParts | undefined;

    if (conditions.length === 0 || actions.length === 0) {
      // We may want to get the same data from the description
      predicates = dependenciesRule.description ? this.parseRuleString(dependenciesRule.description, modelTree.selected) : undefined;
      if (!predicates) {
        console.log(`rule.descritpion = ${dependenciesRule.description}`);
        return _.cloneDeep(modelTree);
      }
    }

    // Let's first retrieve the list of values that later will be the  ones allowed in the actioned tree elements
    const conditionPredicates = predicates ? predicates.conditions : this.getConditionPredicatesFromRuleData(
      dependenciesRule.ruleDataDependencies,
      sltxFile,
      modelTree,
    );

    const conditionValues = this.getPossibleValuesFromSelectedOptions(
      conditionPredicates,
      predicates ? predicates.conditionLevel : 0,
      modelTree.selected,
    );

    // Let's get the predicate to select the actioned tree elements
    const actionPredicates = predicates ? predicates.actions : this.getActionPredicatesFromRuleData(
      dependenciesRule.ruleDataDependencies,
      sltxFile,
      modelTree,
    );

    // And now filter the Option Tree acting on the action targets
    let newModelTree = modelTree;
    actionPredicates.forEach((actionPredicate) => {
      newModelTree = this.actOnOptionTree(
        newModelTree,
        newModelTree,
        conditionValues,
        actionPredicate,
        predicates ? predicates.actionLevel : 0,
      );
    });

    return newModelTree;
  }

  // ----------------------------------------------------------------------------------
  // Transform the Option tree to remove the options in the acted nodes
  // ----------------------------------------------------------------------------------
  private static actOnOptionTree(
    inpuRootOptionTree: ModelTreeNode,
    inputOptionTree: ModelTreeNode,
    actionFilter: RuleValueFilter,
    actionPredicate: string,
    level: number,
  ) : ModelTreeNode {

    if (!actionFilter.includeAll && actionFilter.values.length === 0) return inputOptionTree;

    const optionTree : ModelTreeNode = _.cloneDeep(inputOptionTree);

    if (this.doesPathMatch(`${optionTree.path}/dummy`, actionPredicate, 0, undefined)) {
      // ----------------------------------------------------------------------------------
      // Let's remove the children that don't match the actionValuesand check if we need
      // to reevaluate the selection because we've just removed it from the tree
      // ----------------------------------------------------------------------------------
      let selectionToReevaluate: string | undefined;
      optionTree.children = optionTree.children.filter((childNode) => {

        // Check if we need to Keep or Remove this option.
        // Positive filter: keep only listed values.
        // Negative filter: keep everything except listed values.
        const childValue = this.doesPathMatch(childNode.path, actionPredicate, 0, undefined);
        let toKeep = false;
        if (childValue !== undefined) {
          const isListed = actionFilter.values.includes(childValue);
          toKeep = actionFilter.includeAll ? !isListed : isListed;
        }

        // Let's avoid side effects that are not wanted (that should not happen in the rules are correctly defined)
        switch (level) {
          case 0: toKeep = childNode.type === ParsedTreeNodeType.Option ? toKeep : true;
            break;
          case 1: toKeep = childNode.type === ParsedTreeNodeType.Folder ? toKeep : true;
            break;
          default: toKeep = true;
        }
        // --------------------------------------------------------------------
        // in case we're removing we need to check if it is the selected one
        // --------------------------------------------------------------------
        if (!toKeep) {
          for (let i = 0; inpuRootOptionTree.selected && i < inpuRootOptionTree.selected?.length; i++) {
            const optPath = inpuRootOptionTree.selected[i];
            if (childNode.sltxPath && this.isPathSelected(childNode.sltxPath, optPath, level)) {
              selectionToReevaluate = optPath;
              break;
            }
          }
        }
        return toKeep;
      });

      // ---------------------------------------------------------------------------------
      // we have an option to remove from selected list and need to reevaluate  new value
      // This new value maybe required for the next rule to be evaluated
      // ---------------------------------------------------------------------------------
      if (selectionToReevaluate && inpuRootOptionTree.selected) {
        const reevaluatedOption = this.getFirstLeaf(optionTree);
        for (let i = 0; i < inpuRootOptionTree.selected.length; i++) {
          if (inpuRootOptionTree.selected[i] === selectionToReevaluate) {
            inpuRootOptionTree.selected[i] = reevaluatedOption || selectionToReevaluate;
          }
        }
      }
    }

    const newChildrenTreeNode : ModelTreeNode[] = new Array<ModelTreeNode>();
    optionTree.children.forEach((childNode) => {
      const newNode = this.actOnOptionTree(
        optionTree.type === ParsedTreeNodeType.Root ? optionTree : inpuRootOptionTree,
        childNode,
        actionFilter,
        actionPredicate,
        level,
      );
      newChildrenTreeNode.push(newNode);
    });
    optionTree.children = newChildrenTreeNode;
    return optionTree;
  }

  // -------------------------------------------------------------------------
  // Auxiliary functions to handle and extract paths from options
  // -------------------------------------------------------------------------

  // Transform the Option tree to remove the options in the acted nodes
  public static getFirstLeaf(
    inputOptionTree: ModelTreeNode,
  ) : string | undefined {
    if (inputOptionTree.children.length === 0) {
      return undefined;
    }
    if (inputOptionTree.children[0].type === ParsedTreeNodeType.Option) {
      return inputOptionTree.children[0].sltxPath;
    }
    return this.getFirstLeaf(inputOptionTree.children[0]);
  }

  // ----------------------------------------------------------------------
  // Build a list of possible values based on the current selected values
  // and the condition predicates
  // ----------------------------------------------------------------------
  public static getPossibleValuesFromSelectedOptions(
    predicates: string [],
    level: number,
    optionPaths : string [] | undefined,
  ) : RuleValueFilter {
    // const optionPaths = this.getPathsFromOptionSelection(
    //   sltxFile,
    //   optionsSelectionState,
    // );
    if (!optionPaths) {
      console.log('No option paths!!!!');
      return { includeAll: false, values: [] };
    }

    return this.buildValueFilter(optionPaths, predicates, level);
  }

  // ----------------------------------------------------------------------
  // Build action/dependent path format predicates from the Rule Data
  // ----------------------------------------------------------------------
  public static getActionPredicatesFromRuleData(
    ruleData: ModelRuleDependenciesData,
    sltxFile : SLTXFormatRootFile,
    treeNode: ModelTreeNode,
  ) : string [] {
    const predicates = new Array<string>();

    ruleData.actions.forEach((groupData) => {
      const predicate = this.getActionPredicateFromRuleData(groupData, sltxFile, treeNode);
      if (predicate) {
        predicates.push(predicate);
      }
    });
    return predicates as string [];
  }

  // ----------------------------------------------------------------------
  // Build condition/master path format predicates from the Rule Data
  // ----------------------------------------------------------------------
  public static getConditionPredicatesFromRuleData(
    ruleData: ModelRuleDependenciesData,
    sltxFile : SLTXFormatRootFile,
    treeNode: ModelTreeNode,
  ) : string [] {
    const predicates = new Array<string>();

    ruleData.conditions.forEach((groupData) => {
      const predicate = this.getPredicateFromRuleData(groupData, sltxFile, treeNode);
      if (predicate) {
        predicates.push(predicate);
      }
    });
    return predicates as string [];
  }

  // ----------------------------------------------------------------------
  // Build a path based on the naive RuleData
  // ----------------------------------------------------------------------
  public static getPredicateFromRuleData(
    ruleGroupData: ModelRuleGroupData,
    sltxFile : SLTXFormatRootFile,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    treeNode: ModelTreeNode,
  ) : string {

    if (!ruleGroupData.groupID) return '';

    // const depth = this.findGroupAndCalculateDepth(
    //   ruleGroupData.groupID,
    //   treeNode,
    // );

    let path = '';
    const group = sltxFile.groups?.find((g) => g.id === ruleGroupData.groupID);
    if (group !== undefined) {
      path += `${group.name}`;
      group.optionsFolders.some((folder) => {
        if (folder.name !== 'Root') {
          path += '/*';
          return true;
        }
        return false;
      });
    }
    return path;
  }

  public static getActionPredicateFromRuleData(
    ruleGroupData: ModelRuleGroupData,
    sltxFile : SLTXFormatRootFile,
    treeNode: ModelTreeNode,
  ) : string {

    if (!ruleGroupData.groupID) return '';

    const depth = this.findGroupAndCalculateDepth(
      ruleGroupData.groupID,
      treeNode,
    );

    let path = '';
    const group = sltxFile.groups?.find((g) => g.id === ruleGroupData.groupID);
    if (group !== undefined) {
      path += `${group.name}`;
      if (depth) {
        for (let i = 0; i < depth - 1; i++) {
          path += '/*';
        }
      }
    }
    return path;
  }

  // ----------------------------------------------------------------------
  // Find a node of type Group and calculate depth of its subtree
  // ----------------------------------------------------------------------
  public static findGroupAndCalculateDepth(
    groupId: number,
    treeNode: ModelTreeNode,
  ): number | undefined {
    if (treeNode.id === groupId && treeNode.type === ParsedTreeNodeType.Group) {
      return this.calculateDepth(treeNode);
    }

    for (const child of treeNode.children) {
      const result = this.findGroupAndCalculateDepth(groupId, child);
      if (result !== undefined) {
        return result;
      }
    }
    return undefined;
  }

  public static calculateDepth(treeNode: ModelTreeNode): number {

    if (treeNode.type === ParsedTreeNodeType.Option || treeNode.children.length === 0) {
      return 0;
    }
    return 1 + Math.max(...treeNode.children.map((child) => this.calculateDepth(child)));
  }

  // ----------------------------------------------------------------------
  // Create paths for all the current selected options
  // ----------------------------------------------------------------------
  public static getPathsFromOptionSelection(
    sltxFile : SLTXFormatRootFile,
    optionsSelectionState : TreeOptionSelections,
  ) : string [] {
    const optionsSelectionStateString = optionsSelectionState.map((e) => this.getPathFromOptionSelection(e.groupID, e.optionID, sltxFile));
    return optionsSelectionStateString;
  }

  // ----------------------------------------------------------------------
  // Create paths for a selected option
  // ----------------------------------------------------------------------
  public static getPathFromOptionSelection(
    groupId: number,
    optionId: number,
    sltxFile : SLTXFormatRootFile,
  ) : string {
    let path = '';
    const group = sltxFile.groups?.find((g) => g.id === groupId);
    if (group !== undefined) {
      path += `${group.name}/`;
      group.optionsFolders.some((folder) => {
        const option = folder.options.find((opt) => opt.id === optionId);
        if (option) {
          path += (folder.name !== 'Root') ? `${folder.name}/${option.name}` : `${option.name}`;
          return true;
        }
        return false;
      });
    }
    return path;
  }

  private static getPathLeafs(
    path: string,
    predicate: string,
    level: number,
  ): string | undefined {

    return this.doesPathMatch(
      path,
      predicate,
      level,
      undefined,
    );
  }

  private static doesPathMatchWithOneValue(
    path: string,
    predicate: string,
    values: string[],
    level: number,
  ): boolean {
    let ret = false;
    values.forEach((v : string) => {
      if (this.doesPathMatch(path, predicate, level, v) !== undefined) ret = true;
    });
    return ret;
  }

  private static doesPathMatch(
    path: string,
    predicate: string,
    level: number,
    value: string | undefined,
  ): string | undefined {
    const predParts = predicate.split('/');
    const pathParts = path.split('/');

    for (let i = 0; i < level; i++) pathParts.pop();

    const retValue = pathParts[pathParts.length - 1];
    if (value !== undefined) {
      if (value !== retValue) return undefined;
    }
    pathParts.pop();

    // We just need to match all the pred parts even if path is greater
    if (pathParts.length < predParts.length) return undefined;
    for (let j = predParts.length - 1, k = pathParts.length - 1; j >= 0 && k >= 0; j--, k--) {
      if (predParts[j] !== '*' && predParts[j] !== pathParts[k]) return undefined;
    }
    return retValue;
  }

  private static isPathSelected(
    path: string,
    selection: string,
    level: number,
  ) : boolean {
    return path.endsWith(this.stripPathFromLevel(
      selection,
      level,
    ));
  }

  public static stripPathFromLevel(
    path: string,
    level: number,
  ) : string {
    const pathParts = path.split('/');
    let returnPath = '';
    for (let j = 0; j < pathParts.length - level; j++) {
      returnPath += j === 0 ? `${pathParts[j]}` : `/${pathParts[j]}`;
    }

    return returnPath;
  }

  private static filterPathsAndGetLeafs(
    paths: string[],
    predicate: string,
    level: number,
  ): Set<string> {

    // Set To return Unique leaves
    const results = new Set<string>();
    paths.forEach((path: string) => {
      const leaf = this.getPathLeafs(path, predicate, level);
      if (leaf) results.add(leaf);
    });

    // Return the results Set
    return results;
  }

  private static buildValueFilter(
    paths : string[],
    predicates: string[],
    level: number,
  ) : RuleValueFilter {
    const includedValues = new Set<string>();
    const excludedValues = new Set<string>();

    let hasPositiveSource = false;
    let hasNegativeSource = false;

    predicates.forEach((predicate: string) => {
      const predicateParts = this.decomposePredicate(predicate);
      if (!predicateParts) return;

      if (predicateParts.predicate !== '') {
        const result = this.filterPathsAndGetLeafs(paths, predicateParts.predicate, level);
        if (predicateParts.negativePredicate) {
          hasNegativeSource = true;
          result.forEach((e) => excludedValues.add(e));
        } else {
          hasPositiveSource = true;
          result.forEach((e) => includedValues.add(e));
        }
      }

      predicateParts.plusValues.forEach((e) => {
        hasPositiveSource = true;
        includedValues.add(e);
      });

      predicateParts.minusValues.forEach((e) => {
        hasNegativeSource = true;
        excludedValues.add(e);
      });
    });

    // If at least one positive source exists, we are in whitelist mode:
    // allow included values, then remove exclusions.
    if (hasPositiveSource) {
      excludedValues.forEach((e) => includedValues.delete(e));
      return { includeAll: false, values: Array.from(includedValues) as string[] };
    }

    // If we only have negative sources, we are in blacklist mode:
    // allow everything except excluded values.
    if (hasNegativeSource) {
      return { includeAll: true, values: Array.from(excludedValues) as string[] };
    }

    return { includeAll: false, values: [] };
  }

  private static parseValueList(rawArray: string) : string[] {
    try {
      return JSON.parse(rawArray.replace(/'/g, '"')).map((e: string) => e.trim());
    } catch (e) {
      console.warn(`Invalid value list in dependency rule: ${rawArray}`);
      return [];
    }
  }

  private static decomposePredicate(predicate: string) : ParsedRuleValuePredicate | undefined {
    const trimmed = predicate.trim();
    if (trimmed === '') return undefined;

    const plusValues = new Array<string>();
    const minusValues = new Array<string>();

    // Array operators supported after the predicate:
    //   Leather 1/* + ['val1', 'val2']
    //   Leather 1/* - ['val1', 'val2']
    //   -Leather 1/* + ['val1', 'val2']
    const arrayOpRegex = /([+-])\s*(\[[^\]]*\])/g;
    let firstArrayOperatorIndex = trimmed.length;

    let match: RegExpExecArray | null;
    while ((match = arrayOpRegex.exec(trimmed)) !== null) {
      if (match.index < firstArrayOperatorIndex) {
        firstArrayOperatorIndex = match.index;
      }

      const operator = match[1];
      const values = this.parseValueList(match[2]);
      if (operator === '+') {
        values.forEach((e) => plusValues.push(e));
      } else {
        values.forEach((e) => minusValues.push(e));
      }
    }

    let basePredicate = trimmed.substring(0, firstArrayOperatorIndex).trim();
    let negativePredicate = false;

    if (basePredicate.startsWith('-')) {
      negativePredicate = true;
      basePredicate = basePredicate.substring(1).trim();
    } else if (basePredicate.startsWith('+')) {
      basePredicate = basePredicate.substring(1).trim();
    }

    return {
      predicate: basePredicate,
      negativePredicate,
      plusValues,
      minusValues,
    };
  }

  private static splitRuleList(value: string) : string[] {
    const result = new Array<string>();
    let current = '';
    let bracketDepth = 0;
    let inString = false;
    let stringChar = '';

    for (let i = 0; i < value.length; i++) {
      const ch = value[i];

      if ((ch === '\'' || ch === '"') && value[i - 1] !== '\\') {
        if (!inString) {
          inString = true;
          stringChar = ch;
        } else if (stringChar === ch) {
          inString = false;
          stringChar = '';
        }
      }

      if (!inString) {
        if (ch === '[') bracketDepth++;
        else if (ch === ']') bracketDepth--;

        if ((ch === ';' || ch === ',') && bracketDepth === 0) {
          const item = current.trim();
          if (item !== '') result.push(item);
          current = '';
          continue;
        }
      }

      current += ch;
    }

    const item = current.trim();
    if (item !== '') result.push(item);

    return result;
  }

  // ---------------------------------------------------------------------------------------
  // Extract, in cass it exists, an if statment from the "condition side of the rule"
  // ---------------------------------------------------------------------------------------
  private static parseIfCondition(input: string): ConditionParseResult {
    const trimmedInput = input.trim();

    if (!trimmedInput.startsWith('if')) {
      return {
        condition: '',
        consequence1: trimmedInput,
        consequence2: '',
      };
    }

    let index = 2; // after 'if'
    index = this.skipWhitespace(trimmedInput, index);

    const condition = this.extractBalanced(trimmedInput, '(', ')', index, "Expected '(' after 'if'. Condition missing or unbalanced.");
    index = condition.end;
    index = this.skipWhitespace(trimmedInput, index);

    const consequence1 = this.extractBalanced(trimmedInput, '{', '}', index, "Expected '{' after condition. Consequence1 missing or unbalanced.");
    index = consequence1.end;
    index = this.skipWhitespace(trimmedInput, index);

    const elseIndex = this.findKeyword(trimmedInput, 'else', index);

    if (elseIndex !== -1) {
      index = elseIndex + 4; // after 'else'
      index = this.skipWhitespace(trimmedInput, index);

      const consequence2 = this.extractBalanced(trimmedInput, '{', '}', index, "Expected '{' after 'else'. Consequence2 missing or unbalanced.");

      return {
        condition: condition.content.trim(),
        consequence1: consequence1.content.trim(),
        consequence2: consequence2.content.trim(),
      };
    }

    return {
      condition: condition.content.trim(),
      consequence1: consequence1.content.trim(),
      consequence2: '',
    };
  }
  // ---------------------------------------------------------------------------------------------
  // Check and extract outter most balanced {} or ()
  // ---------------------------------------------------------------------------------------------
  private static extractBalanced(
    str: string,
    openChar: string,
    closeChar: string,
    startIndex: number,
    errorMessage: string,
  ): { content: string; end: number } {
    let depth = 0;
    let content = '';
    let started = false;

    for (let i = startIndex; i < str.length; i++) {
      const ch = str[i];

      if (ch === openChar) {
        depth++;
        if (!started) started = true;
        else content += ch;
      } else if (ch === closeChar) {
        depth--;
        if (depth === 0) {
          return { content: content.trim(), end: i + 1 };
        }
        content += ch;
      } else if (started) {
        content += ch;
      }

      if (started && depth < 0) {
        throw new Error(`${errorMessage} Unbalanced brackets at index ${i}.`);
      }
    }

    if (!started || depth !== 0) {
      throw new Error(`${errorMessage} Unbalanced or missing '${closeChar}'. Reached end of input without closing.`);
    }

    throw new Error(`${errorMessage} Unknown parsing failure.`);
  }

  private static skipWhitespace(str: string, index: number): number {
    while (index < str.length && /\s/.test(str[index])) {
      index++;
    }
    return index;
  }

  private static findKeyword(str: string, keyword: string, startIndex: number): number {
    const pattern = new RegExp(`\\b${keyword}\\b`, 'i');
    const match = pattern.exec(str.substring(startIndex));
    return match ? startIndex + match.index : -1;
  }

  // -------------------------------------------------------------------
  // Extract predicates from description string for more complex rules
  //
  // The base template for these rules are:
  //     <action: option group to be actuated> === <conditions: option groups or values to set>+<list of hardcoded values>
  // or:
  //     <action> === if(<if_condition: option group values check>) {<conditions#1>} else {<conditions#2>}
  //     (after the preprocessing and evaluation of the "if" condition, it will default to the first template internally)
  //
  // Examples without if_condition:
  //  1) group1 === group2/*
  //     The only possible  (and then selected) option of folderless gropup 1
  //     are the same as the optioncurrent selected in any of the folder
  //     of group2
  //
  //  2) group4/folder1 === group2/*;group3/*
  //     The possible options of folder1 under group4 are either option selected
  //     in any of the group2 folders or the one in the any of the
  //     folders 0f group3. Note: Only one folder can be selected at any time
  //     in each group of options.
  //
  //  3) group1 === group2/*;group3/*+['P01','P02']
  //     The possible option for group1 are the ones currently selected for any
  //     folders of group2 or group3 plus "P01" and "P02"
  //
  //  4) Folder:group1 ==== Folder:group2
  //     The possible (and then selected) Folder of group1 is the same as the
  //     one currently selected for group2.
  //
  //  The above rules work on the "option tree" build after the domains
  //  are processed and so the path pattern should take that in consideration
  //  namelly to the folders that might be "removed" from domain groups
  //  hieracrchy because only one is allowed in that domainGroup.
  //
  //  The  if_condition has the following format examples (valid operators are != and ==):
  //
  //    1) group4 == 'folder1/white'
  //    True if group4 is set with folder == folder1 and leaf set to white
  //
  //    2) group4 == '*/White'
  //    True if that group is set with */White, mening any folder can be seletec as long as the leaf is white
  //
  //    3) group4 == ['folder1/*', 'folder2/white', '*/black']
  //    True if  group4 is set with  any folder and leaf black or any leaf and foler1 and folder2/white.
  //
  //  If the if_condition is evaluated to true then  condition1 is set as the rule condition and condition2 otherwhise.
  //  If any of the condition1 or condition2 are empty, then no action is really taken (i.e. is not rule existes)

  // -------------------------------------------------------------------
  private static parseRuleString(description: string, modelTreeSelected : string[] | undefined): RuleParts | undefined {

    const parts = description.split('===').map((part) => part.trim());
    if (parts.length !== 2) {
      return undefined;
    }

    // -------------------------------------------------------------------
    // Let's first check if the actions have a "level" modifier prefix
    // in the form of 'Folder:' or 'Option:'
    // -------------------------------------------------------------------
    let actionLevel = 0;
    let actionPredicates = parts[0];
    const actionLevelParts = parts[0].split(':').map((action) => action.trim());
    if (actionLevelParts.length === 2) {
      actionLevel = actionLevelParts[0] === 'Folder' ? 1 : 0;
      // eslint-disable-next-line prefer-destructuring
      actionPredicates = actionLevelParts[1];
    }

    // -------------------------------------------------------------------
    // Parse the condition string, to evaluate a possible if statement
    // that in fact contains and if_condition and two candidate conditions,
    // where only one to selected once the if_condition is evaluated
    // -------------------------------------------------------------------
    let sCondition = '';
    try {
      const ifResult = this.parseIfCondition(parts[1]);
      sCondition = ifResult.consequence1;
      if (ifResult.condition.trim() !== '') {
        const bConditionResult : boolean = ConditionEvaluator.evaluateIfCondition(ifResult.condition, modelTreeSelected || ['?_Invalid_?']);
        if (bConditionResult) {
          sCondition = ifResult.consequence1;
        } else {
          sCondition = ifResult.consequence2;
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error message:', error.message);
        console.error('Error name:', error.name);
        console.error('Stack trace:', error.stack);
      } else {
        console.error('Unknown error:', error);
      }
      sCondition = '';
    }

    // If there is no condition either because of an error or because no cosequence2 is defined
    // return nil
    if (sCondition.trim() === '') {
      return undefined;
    }
    // -------------------------------------------------------------------
    // And then check if the selected conditions have a "level" modifier prefix
    // -------------------------------------------------------------------
    let conditionLevel = 0;
    let sConditionPredicates = sCondition;
    const conditionLevelParts = sCondition.split(':').map((sAction) => sAction.trim());
    if (conditionLevelParts.length === 2) {
      conditionLevel = conditionLevelParts[0] === 'Folder' ? 1 : 0;
      // eslint-disable-next-line prefer-destructuring
      sConditionPredicates = conditionLevelParts[1];
    }

    // ------------------------------------------------------------------------
    // Now let's split the conditions and actions into to arrays of 'paths'
    // ------------------------------------------------------------------------
    const actions = this.splitRuleList(actionPredicates);
    const conditions = this.splitRuleList(sConditionPredicates);

    return {
      actions,
      actionLevel,
      conditions,
      conditionLevel,
    };
  }
}
